module.exports = __webpack_public_path__ + "img/5.a76e8238.png";